export var LiveScheduleAccessRoutes = {
    "/tl-live-schedule-access": {
        "name": "appLayout.schedule.live-schedule-access",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                component: "liveScheduleContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["live-schedule-access"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./live-schedule-access.module.js");
                }
            }
        ]
    }
};